import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchRosterManagementReport } from "../api/fetchRosterManagementReport/fetchRosterManagementReportApi";
import {
  FetchRosterManagementReportParams,
  RosterManagementReportItem,
} from "../api/fetchRosterManagementReport/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface RosterManagementReportState {
  items: RosterManagementReportItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: RosterManagementReportState = {
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const rosterManagementReportSlice = createSlice({
  name: "rosterManagementReport",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setReport: (
      state,
      action: PayloadAction<{
        items: RosterManagementReportItem[];
        totalCount: number;
      }>,
    ) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setReport } =
  rosterManagementReportSlice.actions;

export const fetchRosterManagementReportAction =
  (params: FetchRosterManagementReportParams = {}): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchRosterManagementReport(params);
      dispatch(
        setReport({
          items: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch roster management report",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default rosterManagementReportSlice.reducer;
